import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import getTriangleStyles from '../get-triangle-styles';
export default function Triangle({ width, height, color, direction }) {
    return (_jsx("div", { style: {
            ...getTriangleStyles({ width, height, color, direction }),
            transition: 'border 250ms ease',
        } }));
}
